import React from 'react'

import './ChangeAliadaSearch.scss'

import ChangeAliadaSearchBase from 'components/ChangeAliadaSearchBase'
import { formatDate } from 'utils/dates'
import Loader from 'components/Loader'
import { serviceTypes } from '@src/globals'

import * as qs from 'utils/querystring'
import * as paths from 'utils/paths'

class ChangeAliadaSearch extends ChangeAliadaSearchBase {
  constructor () {
    super()

    this.navBarLabel = 'Modificar Servicio'
  }

  buildSearchQuerystring (data) {
    const [date, time] = data.datetime.split('T')
    const [hour, minute] = time.split(':')

    const queryobject = {
      date,
      time: `${hour}:${minute}`,
      estimatedHours: data.estimatedHours,
      coordinates: {
        ...data.address.location
      },
      serviceTypeId: serviceTypes.ONE_TIME.id,
      serviceId: data.id,
      sort: data.sort,
      userId: data.userId
    }

    return qs.stringify(queryobject)
  }

  renderFlashMessage (booking) {
    return (
      <div className='ChangeAliadaSearch-flashMessage'>
        <p className='ChangeAliadaSearch-flashMessageTitle'>
          Estas Aliadas están disponibles
        </p>
        <p className='ChangeAliadaSearch-flashMessageContent'>
          Para tu servicio del <strong>{formatDate('dddd D [de] MMMM [a las] H:mm A', booking.datetime)}</strong>
        </p>
      </div>
    )
  }

  renderSearchResults ({searching, searchResults, resultsDisplayed, booking, userId}) {
    return (
      <div className='ChangeAliadaSearch-searchResults'>
        {searching
          ? <Loader text='Buscando' className='ChangeAliadaSearch-searchResultsLoader' />
          : searchResults
              .slice(0, resultsDisplayed)
              .map(aliada => {
                const aliadaProfileUrl = paths.replaceAliadaProfile(userId, aliada.id, serviceTypes.ONE_TIME.id, booking.id, booking.estimatedHours)
                const changeAliadaQueryobject = { replacement_aliada_id: aliada.id }
                const changeAliadaUrl = paths.serviceChangeAliadaConfirm(userId, booking.id, changeAliadaQueryobject)

                const props = {
                  booking,
                  aliada,
                  aliadaProfileUrl,
                  changeAliadaUrl
                }
                return this.renderResult(props)
              })
        }
      </div>
    )
  }
}

ChangeAliadaSearch.displayName = 'ChangeAliadaSearch'

export default ChangeAliadaSearch



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/ChangeAliadaSearch/ChangeAliadaSearch.js